export default "__VITE_ASSET__97fd4da2__"